import axios from 'axios';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';

export const useCommunicationsStore = defineStore('communications', () => {
  const settings = ref(null);
  // Deliberately a plain variable, not a ref: it is control state, not
  // something the UI renders.
  let fetchInFlight = null;
  const toolbar = reactive({ deleteDisabled: true, onDelete: null });
  // An open create/edit screen owns the page, so the tabs above it are hidden.
  // The editor state belongs to the tab component and the tabs are drawn by its
  // parent, so it travels through here rather than through an emit chain.
  const editing = ref(false);

  const setToolbar = ({ deleteDisabled = true, onDelete = null } = {}) => {
    toolbar.deleteDisabled = deleteDisabled;
    toolbar.onDelete = onDelete;
  };

  const clearToolbar = () => setToolbar();

  const setEditing = (value) => {
    editing.value = value === true;
  };

  /** Read once; every caller shares the cached answer or the request in flight. */
  const fetchSettings = async () => {
    if (settings.value) return settings.value;

    fetchInFlight ??= axios.get('/api/communications/settings')
      .then(({ data }) => {
        settings.value = data.data;
        return settings.value;
      })
      .finally(() => {
        fetchInFlight = null;
      });

    return fetchInFlight;
  };

  return {
    settings,
    fetchSettings,
    toolbar,
    setToolbar,
    clearToolbar,
    editing,
    setEditing,
  };
});
